module.exports = __webpack_public_path__ + "img/team1.9d42d5df.jpg";